"use client";
import * as React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import dynamic from "next/dynamic";

const Player = dynamic(() => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player), { ssr: false, });
import Link from "@AdbhutByte/utils/components/Link";
import Button from "@mui/material/Button";

const MuiPlayer = styled(Player)({});

export default function NotFound() {
  return (
    <Container maxWidth={false}>
      <Box py={5} display="flex" flexDirection="column" alignItems="center">
        <Typography sx={{ textAlign: "center" }}>
          Page lost in parallel universe. Retrieval underway using quantum
          mechanics
        </Typography>
        <Box>
          <MuiPlayer
            autoplay={true}
            loop={true}
            src="/reserved/lotties/not-found/404.json"
            sx={{ height: 300, width: 300, textAlign: "center" }}
          />
        </Box>
        <Button
          LinkComponent={Link}
          href="/?error=404_not_found"
          color="secondary"
          variant="contained"
          sx={{ textAlign: "center" }}
        >
          Got to Home
        </Button>
      </Box>
    </Container>
  );
}
